import { useLocation } from '@remix-run/react';

interface Props {
  value?: string;
  redirectToHome?: boolean;
}

const RedirectToHiddenInput = ({ value, redirectToHome = false }: Props) => {
  const location = useLocation();
  const defaultValue = redirectToHome ? `/${location.search}` : `${location.pathname}${location.search}`;
  return <input type="hidden" name="redirect_to" value={value || defaultValue} />;
};

export default RedirectToHiddenInput;
